import React, { useState, useCallback, useEffect } from "react";
import { Form, Tab, Message } from "semantic-ui-react";

export const Surveys = ({
  cdNotificationSurvey,
  cdPaymentSurvey,
  modification,
  onChangeValuesObject,
  errors
}) => {
  const typeObjectPayment = "cdPaymentSurvey";
  const typeObjectNotification = "cdNotificationSurvey";

  const [notificationQuestion, setNotificationQuestion] = useState("");
  const [paymentQuestion, setPaymentQuestion] = useState("");
  const [notificationAnswer, setNotificationAnswer] = useState([]);
  const [paymentAnswer, setPaymentAnswer] = useState([]);

  useEffect(() => {
    const cdNotificationSurveyDataSource = cdNotificationSurvey || {};

    if (cdNotificationSurveyDataSource.question)
      setNotificationQuestion(cdNotificationSurveyDataSource.question);

    if (cdNotificationSurveyDataSource.answer)
      setNotificationAnswer(cdNotificationSurveyDataSource.answer);
  }, [cdNotificationSurvey]);

  useEffect(() => {
    const cdPaymentSurveyDataSource = cdPaymentSurvey || {};

    if (cdPaymentSurveyDataSource.question)
      setPaymentQuestion(cdPaymentSurveyDataSource.question);

    if (cdPaymentSurveyDataSource.answer)
      setPaymentAnswer(cdPaymentSurveyDataSource.answer);
  }, [cdPaymentSurvey]);

  const onChangeNotificationQuestion = useCallback(
    (_, newValue) => setNotificationQuestion(newValue.value),
    []
  );

  const onChangePaymentQuestion = useCallback(
    (_, newValue) => setPaymentQuestion(newValue.value),
    []
  );

  const onChangeNotificationAnswer = useCallback(
    async (_, newValue) => {
      const copyAnswer = Object.assign(notificationAnswer, []);
      copyAnswer[newValue["data-index"]] = newValue.value;
      setNotificationAnswer(copyAnswer);
      const cdNotificationSurveyTemp = Object.assign(cdNotificationSurvey, {
        answer: notificationAnswer
      });
      onChangeValuesObject(typeObjectNotification, cdNotificationSurveyTemp);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [notificationAnswer]
  );

  const onChangePaymentAnswer = useCallback(
    async (_, newValue) => {
      const copyAnswer = Object.assign(paymentAnswer, []);
      copyAnswer[newValue["data-index"]] = newValue.value;
      await setPaymentAnswer(copyAnswer);
      const cdPaymentSurveyTemp = Object.assign(cdPaymentSurvey, {
        answer: paymentAnswer
      });
      onChangeValuesObject(typeObjectPayment, cdPaymentSurveyTemp);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [paymentAnswer]
  );

  useEffect(() => {
    const cdNotificationSurveyTemp = Object.assign(cdNotificationSurvey, {
      question: notificationQuestion
    });
    onChangeValuesObject(typeObjectNotification, cdNotificationSurveyTemp);
  }, [cdNotificationSurvey, notificationQuestion, onChangeValuesObject]);

  useEffect(() => {
    const cdPaymentSurveyTemp = Object.assign(cdPaymentSurvey, {
      question: paymentQuestion
    });
    onChangeValuesObject(typeObjectPayment, cdPaymentSurveyTemp);
  }, [cdPaymentSurvey, onChangeValuesObject, paymentQuestion]);

  const panes = [
    {
      menuItem: "No Interesa",
      render: () => (
        <Tab.Pane attached={false}>
          <Form>
            <Form.Field>
              <label>Pregunta</label>
              <Form.Input
                readOnly={modification === false}
                name="question"
                onChange={onChangeNotificationQuestion}
                value={notificationQuestion}
              />
            </Form.Field>
            {[1, 2, 3, 4, 5].map((item, index) => (
              <Form.Field key={`cdNotificationSurvey_answer_${index}`}>
                <label>Opción respuesta {item}</label>
                <Form.Input
                  readOnly={modification === false}
                  value={notificationAnswer[index] || ""}
                  data-index={index}
                  onChange={onChangeNotificationAnswer}
                />
              </Form.Field>
            ))}
          </Form>
        </Tab.Pane>
      )
    },
    {
      menuItem: "Aprobado",
      render: () => (
        <Tab.Pane attached={false}>
          <Form>
            <Form.Field>
              <label>Pregunta</label>
              <Form.Input
                readOnly={modification === false}
                name="question"
                onChange={onChangePaymentQuestion}
                value={paymentQuestion}
              />
            </Form.Field>
            {[1, 2, 3, 4, 5].map((item, index) => (
              <Form.Field key={`cdPaymentSurvey_answer_${index}`}>
                <label>Opción respuesta {item}</label>
                <Form.Input
                  readOnly={modification === false}
                  value={paymentAnswer[index] || ""}
                  data-index={index}
                  onChange={onChangePaymentAnswer}
                />
              </Form.Field>
            ))}
          </Form>
        </Tab.Pane>
      )
    }
  ];

  return (
    <div>
      {errors.answer ||
      errors.surveys_notification ||
      errors.surveys_payment ? (
        <Message negative>
          <Message.Header>Error</Message.Header>
          <p>
            {errors.answer ||
              errors.surveys_notification ||
              errors.surveys_payment}
          </p>
        </Message>
      ) : null}
      <Tab menu={{ pointing: true }} panes={panes} />
    </div>
  );
};

Surveys.defaultProps = {
  cdNotificationSurvey: { answer: new Array(5), question: "" },
  cdPaymentSurvey: { answer: new Array(5), question: "" }
};
